import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import { useDispatch } from "react-redux";
import { pushAlert } from "../../alerts/alertSlice";
import { adminPricesApi } from "../../../api/admin/prices";

const isApiPriceEqualToPriceValue = (apiPrice, priceValue) => {
    if (!apiPrice || !priceValue) return false;

    return (apiPrice / 100).toFixed(2) === priceValue;
};

const convertApiPriceToPriceValue = (apiPrice) => {
    if (!apiPrice) return "";

    return (apiPrice / 100).toFixed(2);
};

const Price = ({ price, setPrice, focused, focusToNextInput, focusToPrevInput, deletePrice }) => {
    const dispatch = useDispatch();
    const [priceValue, setPriceValue] = useState(
        convertApiPriceToPriceValue(price?.price)
    );
    const inputRef = useRef(null);

    useEffect(() => {
        if (price) {
            setPriceValue(convertApiPriceToPriceValue(price.price));
        }
    }, [price]);

    const handleSaveClick = async () => {
        const value = +(priceValue * 100).toFixed(0); 
        
        let resp = await adminPricesApi.updatePrice(price.id, value);
        if (!resp.ok) {
            dispatch(
                pushAlert({
                    message: resp.err,
                    delay: 1000,
                    type: "danger",
                })
            );
            return;
        }

        setPrice(resp.price);
    };

    const handleDeleteClick = async () => {
        if (!price.id) return;

        const resp = await adminPricesApi.deletePrice(price.id);

        if (!resp.ok) {
            dispatch(
                pushAlert({
                    message: "Something went wrong, please try again",
                    delay: 1000,
                    type: "danger",
                })
            );
            return;
        }

        deletePrice();
        
        dispatch(
            pushAlert({
                message: "Price deleted",
                delay: 1000,
                type: "success",
            })
        )
    };

    const handleEnterClick = (e) => {
        if (e.key !== "Enter") return;

        if (convertApiPriceToPriceValue(price?.price) !== priceValue) {
            handleSaveClick();
        }

        if(e.shiftKey)
            focusToPrevInput();
        else
            focusToNextInput();
    };

    useEffect(() => {
        if (focused && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [focused]);

    return (
        <tr className="">
            <td className="border border-emerald-600 p-2">
                {price.weight.weight}
            </td>
            <td className="border border-emerald-600 ">
                <input
                    ref={inputRef}
                    value={priceValue}
                    className={`text-center border border-gray-600 rounded-xl`}
                    style={{ fontSize: "1rem" }}
                    onChange={(e) => {let value = e.target.value.replace(",", "."); setPriceValue(value)}}
                    onKeyDown={handleEnterClick}
                />
            </td>
            {/* <th className="border border-emerald-600">
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#dc2626",
                        fontSize: "0.7rem",
                        padding: "4px 2px",
                        ":hover": {
                            bgcolor: "#b91c1c",
                        },
                    }}
                    // onClick={handleDeleteButtonClick}
                >
                    Delete
                </Button>
            </th> */}
            <th className="border border-emerald-600">
                <Button
                    disabled={isApiPriceEqualToPriceValue(price?.price, priceValue)}
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#059669",
                        fontSize: "0.7rem",
                        padding: "4px 2px",
                        ":hover": {
                            bgcolor: "#065f46",
                        },
                    }}
                    onClick={handleSaveClick}
                >
                    Save
                </Button>
            </th>
            <th className="border border-emerald-600">
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#dc2626;",
                        fontSize: "0.7rem",
                        padding: "4px 2px",
                        ":hover": {
                            bgcolor: "#b91c1c",
                        },
                    }}
                    onClick={handleDeleteClick}
                >
                    Delete
                </Button>
            </th>
        </tr>
    );
};

export default Price;
